
export const convertImgToBase64 = async (data) => {
    return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(data); 
    reader.onloadend = function() {
        var base64data = reader.result;     
        resolve(base64data)           
    }
    reader.onerror = (error) => {
        reject('')
    }
   })
}
